import React from 'react';

import { DynamicLayoutComponent } from '../../component/dynamic-layout-component';

import type { LayoutProps } from './layout-types';

const REQUIRED_ELEMENTS_COUNT = 1;

export const OneColumnLayout = ({ elements }: LayoutProps) => {
	if (elements.length < REQUIRED_ELEMENTS_COUNT) {
		return null;
	}

	return <DynamicLayoutComponent component={elements[0]} position="single-column" />;
};
